import React, { useState, useEffect, useRef } from "react";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import Leftpanel from "../layout/Leftpanel";
import {
  createAccessToken,
  listAuthToken,
  deleteAuthToken,
  updateAccessToken,
} from "../../../service/AddUser/AddUserService";
import { toast } from "react-toastify";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AccessToken = () => {
  const { t } = useTranslation();
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const [item, setItem] = useState({});

  const _ADD_SHOW = () => {
    // e.preventDefault();
    setShowAdd(true);
  };

  const _ADD_HIDE = () => {
    // e.preventDefault();
    setShowAdd(false);
  };

  const _EDIT_SHOW = (data) => {
    setItem(data);
    // console.log(data)
    // setConnectedSystem(data.ConnectedSystem)
    // setEmail(data.ContactEmail)
    // setToken(data.authtoken)
    // e.preventDefault();
    setShowEdit(true);
  };

  const _EDIT_HIDE = () => {
    // e.preventDefault();
    setShowEdit(false);
  };

  const [accessToken, setAccessToken] = useState([]);
  const _LIST_AUTH_TOKEN = () => {
    listAuthToken((res) => {
      setAccessToken(res.data.list);
    });
  };

  const [email, setEmail] = useState("");
  const [connectedSystem, setConnectedSystem] = useState("");

  const _CREATE_ACCESS_TOKEN = (e) => {
    e.preventDefault();

    let data = {
      isSave: true,
      ContactEmail: email,
      ConnectedSystem: connectedSystem,
    };
    createAccessToken(data)
      .then((res) => {
        // console.log(res);
        toast.success(res.message);
        setEmail("");
        setConnectedSystem("");
        _LIST_AUTH_TOKEN();
        _ADD_HIDE();
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const _UPDATE_DATA = () => {
    let data = {
      isActive: item.isActive,
      ContactEmail: item.ContactEmail,
      ConnectedSystem: item.ConnectedSystem,
      tokenId: item.id,
    };

    updateAccessToken(data)
      .then((res) => {
        toast.success(res.message);
        setEmail("");
        setConnectedSystem("");
        _LIST_AUTH_TOKEN();
        _EDIT_HIDE();
      })
      .catch((err) => {
        // console.log(err);
      });
    // console.log(data, "itemData");
  };

  useEffect(() => {
    _LIST_AUTH_TOKEN();
  }, []);

  // Copy-text-start
  const textRefs = useRef([]);

  const handleCopyClick = (index) => {
    const textToCopy = textRefs.current[index].innerText;

    const copyTextarea = document.createElement("textarea");
    copyTextarea.value = textToCopy;
    document.body.appendChild(copyTextarea);
    copyTextarea.select();
    copyTextarea.setSelectionRange(0, 99999);

    navigator.clipboard
      .writeText(copyTextarea.value)
      .then(() => {
        toast.success("Token Copied");
      })
      .catch((error) => {
        console.error("Failed to copy text: ", error);
      });

    document.body.removeChild(copyTextarea);
  };
  // Copy-text-end

  const _DELETE_ACCESS_TOKEN = (e, id) => {
    e.preventDefault();
    deleteAuthToken(id, (res) => {
      toast.success(res.message);
      _LIST_AUTH_TOKEN();
    });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="dbMain accessToken">
          <Leftpanel breadcm={t("configuration")} />
          <div className="dbRight">
            <Header
              link="/dashboard"
              title={t("access_token")}
              description=""
            />
            <div className="commonBase mb-4">
              <div className="dbtableTop">
                <div className="dbSearch"></div>
                <div className="dbtableSrchbg">
                  <button className="commonButton" onClick={_ADD_SHOW}>
                    {t("add_access_token")}
                  </button>
                </div>
              </div>
              <div className="dbMaintable respTable tokenTable">
                <table>
                  <thead>
                    <tr>
                      <th>{t("token")}</th>
                      <th>{t("creation_time")}</th>
                      <th>{t("contact_email")}</th>
                      <th>{t("connected_system")}</th>
                      <th>{t("status")}</th>
                      <th>{t("action")}</th>
                    </tr>
                    {accessToken.length > 0 &&
                      accessToken.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <div className="accbg">
                                <div className="tokenBg">
                                  <p
                                    ref={(el) => (textRefs.current[index] = el)}
                                    className="text-to-copy"
                                  >
                                    {item?.authtoken}
                                  </p>
                                </div>
                                <span className="copyTxt">
                                  <button
                                    className="copy-button"
                                    onClick={() => handleCopyClick(index)}
                                  >
                                    <i className="fa-regular fa-copy"></i>
                                  </button>
                                </span>
                              </div>
                            </td>
                            <td>
                              {moment(item?.createdAt).format(
                                "DD-MM-YYYY,HH:mm:ss"
                              )}
                            </td>
                            <td>{item.ContactEmail}</td>
                            <td>{item.ConnectedSystem}</td>
                            <td>
                              <span className="statusActv">
                                {item.isActive ? t("active") : t("inactive")}
                              </span>
                            </td>
                            <td>
                              <button
                                className="trash"
                                onClick={(e) => _EDIT_SHOW(item)}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </button>

                              <button
                                className="trash"
                                onClick={(e) =>
                                  _DELETE_ACCESS_TOKEN(e, item.id)
                                }
                              >
                                <i className="fa-solid fa-trash-can"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Modal for Adding Access Token */}
        <Modal
          size="lg"
          centered
          show={showAdd}
          onHide={_ADD_HIDE}
          className="pastorderModal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("add_access_token_modal")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3 row">
              <label className="col-sm-4 col-form-label">
                {t("enter_contact_email")}
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="mb-3 row">
              <label className="col-sm-4 col-form-label">
                {t("enter_connected_system")}
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setConnectedSystem(e.target.value)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-start">
            <button
              className="commonButton mt-3"
              onClick={_CREATE_ACCESS_TOKEN}
            >
              {t("add")}
            </button>
          </Modal.Footer>
        </Modal>

        {/* Modal for Editing Access Token */}
        <Modal
          size="lg"
          centered
          show={showEdit}
          onHide={_EDIT_HIDE}
          className="pastorderModal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("edit_access_token_modal")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3 row">
              <label className="col-sm-4 col-form-label">
                {t("enter_contact_email")}
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  defaultValue={item?.ContactEmail}
                  onChange={(e) =>
                    setItem({ ...item, ContactEmail: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="mb-3 row">
              <label className="col-sm-4 col-form-label">
                {t("enter_connected_system")}
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  defaultValue={item?.ConnectedSystem}
                  onChange={(e) =>
                    setItem({
                      ...item,
                      ConnectedSystem: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="mb-3 row">
              <div className="form-check form-switch">
                <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckDefault"
                >
                  {t("status")}
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault"
                  defaultChecked={item?.isActive}
                  onChange={(e) =>
                    setItem({
                      ...item,
                      isActive: e.target.checked,
                    })
                  }
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-start">
            <button className="commonButton mt-3" onClick={_UPDATE_DATA}>
              {t("save")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default AccessToken;
